"use client";
import React, { useState } from "react";
import Image from "next/image";
import Link from "next/link";
import "@/app/serviceslist.css";
import StartTrialBtn from "../StartTrialBtnProducts";
import IndustryComponent from "@/component/CloudServices/IndustryComponent";
import IncreasedSecurityReady from "@/Helper/images/increased-security.svg";
import CloudListTABSection from "@/component/CloudServices/CloudListTabSection";
export default function CloudServices() {


  return (
    <>
      <section className="banner_bg1 CloudServicesbg">
        <div className="container banner_container1">
          <div className="banner_inner">
            <div className="banner_left">
              <h1 className="banner_heading1">
              Elevate. Innovate. Scale.
              </h1>
              <p className="banner_text1">
              Harness the power of the cloud with our tailored services. Drive innovation, ensure agility, and scale
              effortlessly to meet the demands of a dynamic business landscape.
              </p>
              <div className="banner_btn_container">
                <StartTrialBtn Text={"Get Started Today"} />
              </div>
            </div>
          </div>
        </div>
      </section>
      <CloudListTABSection/>
   
      <section className="industry_bg1">
        <div className="container industry_containerouter1">
          <div className="common_titbox common_titboxcenter"><h2 className="common_hd">Why Choose iKnot?</h2>
          </div>
          <IndustryComponent />
        </div>
      </section>
      <section className="cta_outer cloudservicesctabg">
        <div className="container cta_container">
          <div className="cta_inner">
          <div className="cta_innerout1">
            <div className="cta_left1">
              <h3 className="cta_hd">Looking to unlock the full potential of your data in the cloud?</h3>
              <p className="cta_desc">Get in touch with our experts to harness Azure, Fabric, Databricks, and Snowflake for scalable, secure, and efficient cloud data solutions!</p>
              <div className="banner_btn_container">
                <StartTrialBtn Text={"Get Started"} />
              </div>
            </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
